import React from "react";
import { Box } from "@mui/material";
import { ProductId } from "../product";
import BusinessBaseFormSection from "./BusinessBaseFormSection";
import BookingBusinessSettingsForm from "../../../products/booking/forms/BookingBusinessSettingsForm";

type Props = {
  productId: ProductId;
  baseFormProps: any;
  careFormProps: any;
  bookingFormProps: any;
};

export default function BusinessSettingsPage({
  productId,
  baseFormProps,
  careFormProps,
  bookingFormProps,
}: Props): JSX.Element {
  return (
    <Box sx={{ width: "100%", mx: "auto", minWidth: 0,
      '& .MuiAccordion-root': {
        bgcolor: 'background.paper', backgroundImage: 'none',
        border: '1px solid', borderColor: 'divider', borderRadius: 2,
        boxShadow: 'none', mt: 2, mb: 0,
        '&:before': { display: 'none' },
        '&:first-of-type': { mt: 0 },
      },
      '& .MuiAccordionSummary-root': { minHeight: 56 },
      '& .MuiAccordionSummary-content .MuiTypography-root': { fontSize: '0.9375rem', fontWeight: 600 },
    }}>
      <BusinessBaseFormSection {...baseFormProps} productId="booking" />
      <BookingBusinessSettingsForm {...bookingFormProps} />
    </Box>
  );
}
